import { ActionTypes } from "../../constants/ActionTypes";
import { IInstancePrarams, IRouteHistory } from "../../interfaces/Instance";

const INIT_STATE = {
  instance: [],
  params: {},
  loadingInstance: true,
  endOfList: false,
  deleteReferWaiting: true,
  restoreLetterWaiting: true,
  deleteReferArgs: {},
  restoreLetterArgs: {},
  routeHistory: [],
  fgInstance: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.ROUTE_HISTORY: {
      let s = { ...state };
      let params: IRouteHistory = action.payload;

      switch (params.command) {
        case "add":
          if (s.routeHistory.length > 5) s.routeHistory.shift();
          s.routeHistory.push(params.route as never);
          break;
        case "remove":
          s.routeHistory.pop();
          break;
      }

      return {
        ...s,
      };
    }

    case ActionTypes.GET_LIST_INSTANCE: {
      // TODO Refactor
      let stateClone = { ...state };

      if (action.payload.pageIndex === 0) {
        stateClone.instance = [];
        stateClone.endOfList = false;
        stateClone.params = action.payload;
      }

      let params: IInstancePrarams = stateClone.params as IInstancePrarams;
      params.pageIndex = action.payload.pageIndex;

      stateClone.params = params;
      stateClone.loadingInstance = true;

      let model = {
        folderCode: action.payload.folderCode,
        pageIndex: action.payload.pageIndex,
        searchText: action.payload.searchText,
        folderId: action.payload.folderId,
        referTypeId: action.payload.referTypeId,
        list: [],
      };

      return {
        ...stateClone,
        fgInstance: [...stateClone.fgInstance, model],
      };
    }

    case ActionTypes.CLEAR_LIST_INSTANCE: {
      return {
        ...state,
        instance: [],
      };
    }

    case ActionTypes.FETCH_LIST_INSTANCE_SUCCESS: {
      return {
        ...state,
        instance: [...state.instance, ...action.payload],
        loadingInstance: false,
        endOfList: action.payload.length < 20,
      };
    }

    case ActionTypes.DELETE_REFER: {
      return {
        ...state,
        deleteReferWaiting: true,
        deleteReferArgs: action.payload,
      };
    }

    case ActionTypes.DELETE_REFER_SUCCESS: {
      return {
        ...state,
        deleteReferWaiting: false,
      };
    }

    case ActionTypes.RESTORE_LETTER: {
      return {
        ...state,
        restoreLetterWaiting: true,
        restoreLetterArgs: action.payload,
      };
    }

    case ActionTypes.RESTORE_LETTER_SUCCESS: {
      return {
        ...state,
        restoreLetterWaiting: false,
      };
    }

    default:
      return state;
  }
};
